import { Dispatch } from 'redux';
import {
  ACTION_REDEEM_CRC_POINTS,
  ACTION_REDEEM_CRC_POINTS_SUCCESS,
  ACTION_REDEEM_CRC_POINTS_FAILURE,
  API_CALL,
} from '../../configs/ActionTypes';
import { getSingle } from './GetSingle';

export function redeemCRCPoints(
  bookingId: string,
  onSuccess?: (data: any) => void,
  onFail?: (error: any) => void,
) {
  return (dispatch: Dispatch) => {
    dispatch({ type: ACTION_REDEEM_CRC_POINTS, payload: null });

    dispatch({
      type: API_CALL,
      payload: {
        call: `bookings/${bookingId}/redeem-points`,
        method: 'post',
        data: JSON.stringify({}),
        success: (response: any) => {
          dispatch(requestSuccess(response));
          onSuccess?.(response.payload);
        },
        fail: (error: any) => {
          dispatch(requestFailed(error));
          onFail?.(error);
        },
      },
    });
  };
}

function requestSuccess(response: any) {
  return {
    type: ACTION_REDEEM_CRC_POINTS_SUCCESS,
    payload: response,
  };
}

function requestFailed(error: any) {
  return {
    type: ACTION_REDEEM_CRC_POINTS_FAILURE,
    payload: error,
  };
}
